<script setup>
  import '@mdi/font/css/materialdesignicons.min.css'
  import { ref, computed, onMounted, watch } from 'vue'
  import { useStore } from 'vuex'
  import bus from './plugins/bus.js'
  import mitt from 'mitt'
  import CSSRootTransitions from './transitions/CSSRootTransitions.vue'
  import Connecting from './components/Connecting/Connecting.vue'
  import { useSnackbarNotificationQueue } from './composables/useSnackbarNotificationQueue.js'

  const store = useStore()
  // const bus = mitt()
  const {
    notification,
    notificationText,
    notificationColor,
    notificationButtonColor,
    notificationTimeout,
    notificationTop,
    notificationBottom,
    notificationLeft,
    notificationRight,
    notificationMultiLine,
    notificationDark,
    notificationDismiss,
    addNotification,
    clearNotifications,
  } = useSnackbarNotificationQueue()
  const connecting = ref(false)
  const appVersion = computed(() => store.getters.appVersion)
  onMounted(() => {
    bus.on('notification', (payload) => {
      // support both old (string + options) and new ({message, options}) styles
      if (typeof payload === 'string' || payload instanceof Error) {
        if (!payload) return;
        addNotification(payload) // no options available if someone emits the old way
      } else {
        const { message, options } = payload || {}
        if (!message) return;
        addNotification(message, options)
      }
    })
    bus.on('notification-close', () => {
      clearNotifications();
    });
    // Checking for new version every 5 minutes.
    const coms = store.state.coms
    setInterval(() => {
      if (coms && coms.versioning) {
        coms.versioning.checkVersion(appVersion.value, (err, response) => {
          if (err) {
            console.error(err)
          } else if (response === 'new version available') {
            console.log('new version available')
            const updateNotice = document.getElementById('update-notice')
            if (updateNotice) {
              updateNotice.classList.remove('hide')
            }
            setTimeout(() => {
              store.commit('setNewVersionAvailable', true)
            }, 5000)
          }
        })
      }
    }, 5 * 60 * 1000)
  })
  watch(() => store.state.connected, (newVal) => {
    // Prevent scrolling on the connect page.
    if (newVal) {
      document.documentElement.classList.remove('overflow-y-hidden')
    } else {
      document.documentElement.classList.add('overflow-y-hidden')
    }
    connecting.value = !newVal
  }, { immediate: true })

</script>

<template>
  <div class="relative">
    <v-app>
      <v-snackbar
        v-model="notification"
        :color="notificationColor"
        :timeout="notificationTimeout"
      >
        <span v-html="notificationText"></span>
        <template #actions>
          <v-btn
            variant="text"
            :color="notificationButtonColor"
            :ripple="false"
            v-if="notificationDismiss"
            @click="notification = false; $store.commit('clearDeauthenticatedEvent')"
          >
            Dismiss
          </v-btn>
        </template>
      </v-snackbar>
      <connecting class="connecting" v-if="connecting"></connecting>
      <v-main>
        <router-view v-slot="{ Component }">
          <c-s-s-root-transitions>
            <component :is="Component" @hook:mounted="() => console.log('Mounted', Component)" />
          </c-s-s-root-transitions>
        </router-view>
      </v-main>
    </v-app>
  </div>
</template>

<style scoped>
.connecting {
  position: fixed;
  z-index: 1000;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}.relative {
  position: relative;
}
</style>
